module.exports = __webpack_public_path__ + "static/media/about-why-2-image.95faafbd.png";